export default __webpack_public_path__ + "media/images/theme/wordmark_dark-5d493c1c19608b928bf3415e7b4b75a4.png";